import { buildModelManager } from "../builder.js";
const DefaultShiftUnlockTokenSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  errorMessage: true,
  expiresAt: true,
  fisdapShiftId: true,
  instructorEmail: true,
  instructorName: true,
  ipAddress: true,
  shiftId: true,
  studentName: true,
  token: true,
  unlockMessage: true,
  updatedAt: true,
  usedAt: true,
  wasSuccessful: true
};
const modelApiIdentifier = "shiftUnlockToken";
const pluralModelApiIdentifier = "shiftUnlockTokens";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShiftUnlockTokenSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShiftUnlockTokenSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShiftUnlockTokenSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShiftUnlockTokenSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShiftUnlockTokenSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShiftUnlockTokenSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShiftUnlockTokenSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByToken",
    findByField: "token",
    findByVariableName: "token",
    modelApiIdentifier,
    defaultSelection: DefaultShiftUnlockTokenSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByToken",
    findByField: "token",
    findByVariableName: "token",
    modelApiIdentifier,
    defaultSelection: DefaultShiftUnlockTokenSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createShiftUnlockToken",
    operationReturnType: "CreateShiftUnlockToken",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      shiftUnlockToken: { required: false, type: "CreateShiftUnlockTokenInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShiftUnlockTokenSelection
  },
  {
    type: "action",
    operationName: "bulkCreateShiftUnlockTokens",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateShiftUnlockTokensInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultShiftUnlockTokenSelection
  },
  {
    type: "action",
    operationName: "updateShiftUnlockToken",
    operationReturnType: "UpdateShiftUnlockToken",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      shiftUnlockToken: { required: false, type: "UpdateShiftUnlockTokenInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShiftUnlockTokenSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateShiftUnlockTokens",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateShiftUnlockTokensInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultShiftUnlockTokenSelection
  },
  {
    type: "action",
    operationName: "deleteShiftUnlockToken",
    operationReturnType: "DeleteShiftUnlockToken",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteShiftUnlockTokens",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertShiftUnlockToken",
    operationReturnType: "UpsertShiftUnlockToken",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      shiftUnlockToken: { required: false, type: "UpsertShiftUnlockTokenInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateShiftUnlockTokenResult": { hasReturnType: false },
      "... on UpdateShiftUnlockTokenResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShiftUnlockTokenSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertShiftUnlockTokens",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertShiftUnlockTokensInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultShiftUnlockTokenSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "shiftUnlockTokenGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ShiftUnlockTokenManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShiftUnlockTokenSelection,
  operations
);
export {
  DefaultShiftUnlockTokenSelection,
  ShiftUnlockTokenManager
};
//# sourceMappingURL=ShiftUnlockToken.js.map
